
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/signout",
      function () {
        return require("private-next-pages/auth/signout.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/signout"])
      });
    }
  